import { DrawingParsing, GetDigitalHumanVideo,GenerateDigitalHumanAudio } from '@/api/numberPerson';
import store from '@/store';
 /**获取数字人视频 */
 export function getDigitalHumanVideo(id) {
    return new Promise(resolve=>{
        GetDigitalHumanVideo(id).then(res => {
            if (res.code === 200) {
               resolve(res.data);
            }
        });
    })
};
export function numberPersonLoading(imgUrl, currentPage,callback) {
    return new Promise((resolve, reject) => {
        const userName = store.state.user.userInfo.id;
        let obj={
            key:currentPage,
            values:null,
        }
        let dataObj={};
        typeof callback === 'function' && callback(obj);
        /**内容分片 */
        function contentChunk(content='',limit=20){
            content=content.replace(/[^a-zA-Z0-9\u4e00-\u9fa5，。！？；：,.!?;:\s]/g, '');
            let arr=[];
            let str='';
            for(let i=0;i<=content.length-1;i++){
                str=str+content[i];
                let flag=['.','。','?','!','？','！',';','；',',','，',':'].includes(str);
                if(flag||str.length==limit||i==content.length-1){
                    arr.push(str);
                    str='';
                }
            }
            return arr;
        };
        /**解析图片 */
        function drawingParsing() {
            let params = {
                imgUrl: imgUrl,
                userName: userName,
            };
            DrawingParsing(params).then(async(res) => {
                let chunks=contentChunk(res.msg);
                for(let i=0;i<chunks.length-1;i++){
                    await generateDigitalHumanAudio(chunks[i],i); // 调用生成数字人视频方法
                }
                obj.values=dataObj;
                resolve();
                typeof callback === 'function' && callback(obj);
            }).catch(err=>{
                reject(obj);
            });
        };
        /**生成音频 */
        function generateDigitalHumanAudio(context,index){
            if(!context)return;
            return new Promise((resolve,reject)=>{
                let data={
                    "modelId": store.state.course.currentModelId||"240a95c1-4701-4402-86dd-21aeac7da820",
                    "userName": userName,
                    "context": context
                };
                GenerateDigitalHumanAudio(data).then(res=>{
                    if(res.code==200){
                        dataObj[index]=res.data;
                        resolve();
                    }
                }).catch(err=>{
                    reject(obj);
                })
            })
        };
        drawingParsing();
    });
}